<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-dialog
        v-model="dialogRemove"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogRemove"
      >
      <v-card class="no__padding">
        <v-card-title>
          <h2>Smazání objednávky</h2>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          Opravu chcete smazat <strong>Lorem ipsum</strong> z objednávek?
        </v-card-text>
        <v-divider class="mt-2 mb-2"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red elevation-0" dark @click="remove"><v-icon class="mr-2">delete</v-icon>Smazat</v-btn>
          <v-btn color="grey elevation-0 lighten-3" @click="dialogRemove=false" v-if="!removing">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <div v-if="!editMode">
              <v-card color="grey lighten-4" class="pt-3 pr-3 pb-0 pl-3 no__radius">
                <v-breadcrumbs divider="/" large disabled="false" class="pa-0">
                  <v-icon slot="divider">chevron_right</v-icon>
                  <v-breadcrumbs-item>
                    <v-btn color="blue" outline @click="gotoall" class="ma-0">Objednávky jedn. produktů</v-btn>
                  </v-breadcrumbs-item>
                  <v-breadcrumbs-item>
                    {{item.variabilni_symbol}}
                  </v-breadcrumbs-item>
                </v-breadcrumbs>
                <v-card-text class="pl-0 pr-0 mt-2">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <h2>Detail objednávky jednorázového produktu</h2>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="mt-3">
                    <v-flex xs12 sm4>
                      <p>
                        Datum objednávky: <strong>{{ item.datum | formatDate }}</strong>
                      </p>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <p>
                        Měna: <strong>{{item.mena.zkratka}}</strong>
                      </p>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <p>
                        Způsob doručení: <strong v-if="item.zpusob_doruceni!=null">{{item.zpusob_doruceni.nazev}}</strong><strong v-else>--</strong>
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="mt-2">
                    <v-flex xs12>
                      <p>
                        <!--<stav-objednavky v-model="item.stav_objednavky_id" class="mx-3"></stav-objednavky>-->
                        Stav objednávky: <strong>{{item.stav_objednavky.nazev}}</strong>
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="mt-2" v-if="item.prenesena_dan">
                    <v-flex xs12>
                      <p class="red--text">
                        Přenesená daňová povinnost
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="mt-4 mb-2 mx-1">
                    <v-flex xs12 sm4>
                      <h4>Fakturační adresa:</h4>
                      <div class="mt-2">
                        <v-layout row wrap>
                          <v-flex xs12 sm6>
                            <p class="mx-3 mb-0">{{ item.fa_adresa.jmeno }} {{ item.fa_adresa.prijmeni }}</p>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12 sm6>
                            <p class="mx-3 mb-0 mt-1" v-if="item.fa_adresa.typ_osoby=='po'">{{ item.fa_adresa.nazev_firmy }}</p>
                            <p class="mx-3 mb-0 mt-1" v-if="item.fa_adresa.typ_osoby=='po'||item.fa_adresa.typ_osoby=='osvc'">IČ: <span v-if="item.fa_adresa.ic!=null&&item.fa_adresa.ic.length>0">{{ item.fa_adresa.ic }}</span><span v-else>--</span>, DIČ: <span v-if="item.fa_adresa.dic!=null&&item.fa_adresa.dic.length>0">{{ item.fa_adresa.dic }}</span><span v-else>--</span></p>
                            <p class="mx-3 mb-0 mt-1">Tel.: <span v-if="item.fa_adresa.telefon!=null&&item.fa_adresa.telefon.length>0">{{ item.fa_adresa.telefon }}</span><span v-else>--</span></p>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <p class="mx-3 mb-0 mt-1"><span v-if="item.fa_adresa.ulice!=null&&item.fa_adresa.ulice.length>0">{{ item.fa_adresa.ulice }}</span><span v-else>Ulice: --</span></p>
                            <p class="mx-3 mb-0 mt-1"><span v-if="item.fa_adresa.mesto!=null&&item.fa_adresa.mesto.length>0">{{ item.fa_adresa.mesto }}</span><span v-else>Město: --</span></p>
                            <p class="mx-3 mb-0 mt-1"><span v-if="item.fa_adresa.psc!=null&&item.fa_adresa.psc.length>0">{{ item.fa_adresa.psc }}</span><span v-else>PSČ: --</span></p>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <h4 class="mx-3">Dodací adresa:</h4>
                      <div class="mt-2">
                        <v-layout row wrap>
                          <v-flex xs12 sm6>
                            <p class="mx-3 mb-0">{{ item.dod_adresa.jmeno }} {{ item.dod_adresa.prijmeni }}</p>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12 sm6>
                            <p class="mx-3 mb-0 mt-1" v-if="item.dod_adresa.typ_osoby=='po'">{{ item.dod_adresa.nazev_firmy }}</p>
                            <p class="mx-3 mb-0 mt-1" v-if="item.dod_adresa.typ_osoby=='po'||item.dod_adresa.typ_osoby=='osvc'">IČ: <span v-if="item.dod_adresa.ic!=null&&item.dod_adresa.ic.length>0">{{ item.dod_adresa.ic }}</span><span v-else>--</span>, DIČ: <span v-if="item.dod_adresa.dic!=null&&item.dod_adresa.dic.length>0">{{ item.dod_adresa.dic }}</span><span v-else>--</span></p>
                            <p class="mx-3 mb-0 mt-1">Tel.: <span v-if="item.dod_adresa.telefon!=null&&item.dod_adresa.telefon.length>0">{{ item.dod_adresa.telefon }}</span><span v-else>--</span></p>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <p class="mx-3 mb-0 mt-1"><span v-if="item.dod_adresa.ulice!=null&&item.dod_adresa.ulice.length>0">{{ item.dod_adresa.ulice }}</span><span v-else>Ulice: --</span></p>
                            <p class="mx-3 mb-0 mt-1"><span v-if="item.dod_adresa.mesto!=null&&item.dod_adresa.mesto.length>0">{{ item.dod_adresa.mesto }}</span><span v-else>Město: --</span></p>
                            <p class="mx-3 mb-0 mt-1"><span v-if="item.dod_adresa.psc!=null&&item.dod_adresa.psc.length>0">{{ item.dod_adresa.psc }}</span><span v-else>PSČ: --</span></p>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-card color="grey lighten-4 mx-3 mt-4 pl-1">
                    <h4 class="mx-0">Produkty v objednávce:</h4>
                    <v-data-table
                      :headers="productsHeaders"
                      :items="item.produkty"
                      hide-controls
                      class="mt-2"
                    >
                      <template slot="items" slot-scope="props">
                        <tr>
                          <td>
                            <router-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank" v-if="props.item.produkt!=null">{{props.item.produkt.nazev}}</router-link>
                            <span v-if="props.item.postovne">Poštovné</span>
                          </td>
                          <td class="text-xs-right">
                            {{props.item.castka_mj | formatPrice}}&nbsp;{{item.mena.zkratka}}
                          </td>
                          <td class="text-xs-right">
                            {{props.item.mnozstvi | formatPrice}}
                          </td>
                          <td class="text-xs-right">
                            {{props.item.castka | formatPrice}}&nbsp;{{item.mena.zkratka}}
                          </td>
                        </tr>
                      </template>
                      <template slot="footer">
                        <tr>
                          <td>Celkem bez DPH:</td>
                          <td colspan="3" class="text-xs-right">
                            {{item.castka_celkem_bez_dph | formatMoney}} {{item.mena.zkratka}}
                          </td>
                        </tr>
                        <tr v-if="item.castka_celkem_dph_10>0">
                          <td>DPH 10%</td>
                          <td colspan="3" class="text-xs-right">
                            {{item.castka_celkem_dph_10 | formatMoney}} {{item.mena.zkratka}}
                          </td>
                        </tr>
                        <tr v-if="item.castka_celkem_dph_15>0">
                          <td>DPH 15%</td>
                          <td colspan="3" class="text-xs-right">
                            {{item.castka_celkem_dph_15 | formatMoney}} {{item.mena.zkratka}}
                          </td>
                        </tr>
                        <tr v-if="item.castka_celkem_dph_21>0">
                          <td>DPH 21%</td>
                          <td colspan="3" class="text-xs-right">
                            {{item.castka_celkem_dph_21 | formatMoney}} {{item.mena.zkratka}}
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Celkem s DPH:</strong></td>
                          <td colspan="3" class="text-xs-right">
                            <strong>{{item.castka_celkem | formatMoney}} {{item.mena.zkratka}}</strong>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                  <v-card color="grey lighten-4 mx-3 mt-4">
                    {{item.poznamka}}
                  </v-card>
                </v-card-text>
              </v-card>

              <v-card-actions class="mt-4">
                <!--<v-btn color="primary" @click="editMode=true" class="elevation-0"><v-icon small class="mr-2">edit</v-icon>Upravit</v-btn>-->
                <v-btn color="primary" flat class="elevation-0"><v-icon small>picture_as_pdf</v-icon>Generovat objednávky v PDF</v-btn>
                <v-spacer></v-spacer>
                <!--<v-btn color="red" @click="removeClick" flat><v-icon small class="mr-2">delete</v-icon>Smazat</v-btn>-->
              </v-card-actions>
            </div>

            <div v-else>
              <v-card color="grey lighten-4" class="pt-3 pr-3 pb-0 pl-3 no__radius">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <p class="body-2 mb-0 bold">Detail objednávky spořícího produktu</p>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="mt-3">
                    <v-flex xs12 sm6 md3>
                      <v-text-field label="Datum" class="mx-2"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field label="Č. objednávky (VS)" class="mx-2"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <clientsearch label="Jméno a příjmení" class="mx-2"></clientsearch>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field label="Adresa" class="mx-2"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="mt-3">
                    <v-flex xs12 sm6 md3>
                      <v-text-field label="Telefon" class="mx-2"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field label="Email" class="mx-2"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field label="IČ" class="mx-2"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field label="DIČ" class="mx-2"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="mt-3">
                    <v-flex xs12 sm6 md3>
                      <v-text-field label="Č. účtu" class="mx-2"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-select
                        class="mx-2"
                        :items="prevzeti"
                        label="Způsob převzetí"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>

              <v-card-actions class="mt-4">
                <v-btn color="primary" @click="editMode=false" class="elevation-0"><v-icon small class="mr-2">save</v-icon>Uložit</v-btn>
                <v-btn color="red" flat @click="editMode=false"><v-icon small class="mr-2">rotate_left</v-icon>Vrátit změny</v-btn>
              </v-card-actions>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      editMode: false,
      dialogRemove: false,
      removing: false,
      promenna: null,
      prevzeti: [
        'Poradcem',
        'Poštou',
        'Osobně'
      ],
      item: null,
      productsHeaders: [
        { text: "Produkt", value: "produkt", sortable: false },
        { text: "Cena MJ", value: "ceny", sortable: false, width: 150, align: "right" },
        { text: "Počet", value: "pocet", sortable: false, width: 150, align: "right" },
        { text: "Cena celkem", value: "ceny", sortable: false, width: 150, align: "right" }
      ]
    }
  },
  props: {
    id: String
  },
  mounted: function() {
    this.load();
  },
  methods: {
    load: function() {
      window.API.get("prehledy/jednorazove-nakupy/" + this.$props.id).then(function(body) {
        this.item = body;
        this.loading = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    removeClick () {
      //this.removeItem = window.th.copy(this.item);
      this.dialogRemove = true;
    },
    gotoall () {
      this.$router.push({ path: "/objednavky-jednorazove" });
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/KlientiSpolupracovnici/ObjednavkyJednorazovychProduktuDetail.vue